import React, { useState, memo, useEffect } from "react";
import { Box, Flex, Stack } from "@chakra-ui/react";
import Navbar from "../Navbar/Navbar";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import SideBar from "../Sidebar/index";
import { useSelector } from "react-redux";

const Landing = () => {
  const [, setItemNumber] = useState(1);

  const location = useLocation();
  const navigate = useNavigate();

  // const isAuth = useSelector((state) => state.auth.isAuth);
  // useEffect(() => {
  //   console.log("isAuth", isAuth);
  //   if (!isAuth) {
  //     navigate("/login");
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [isAuth]);

  const [navSize, changeNavSize] = useState("small");

  return (
    <>
      <Navbar />
      <Flex>
        <Box w={navSize === "large" ? "13%" : "6%"}>
          <SideBar navSize={"small"} changeNavSize={changeNavSize} />
        </Box>
        <Stack
          h="auto"
          w={navSize === "large" ? "87%" : "94%"}
          overflowY="scroll hidden"
          align="center"
        >
          <Outlet />
        </Stack>
      </Flex>
    </>
  );
};

export default memo(Landing);
